import React from "react"
import { connect } from "react-redux"
import { Button, FormField } from "buoy-core"
import { colors } from "buoy-theme"
import styled from "styled-components"
import { validateEmail } from "../../common/common"
import Text from '../../common/components/Text'
import {
  setProfileInterestEmail,
  submitProfileInterestEmail,
  setProfileInterestError,
  setProfileInterestAttempted,
} from "../actions"

// profile interest a/b test options
const signUpOptions = [{
  term: "r1",
  reason: "for a shorter interview next time"
}, {
  term: "r2",
  reason: "for a more efficient interview next time"
}, {
  term: "r3",
  reason: "for a more accurate interview next time"
}, {
  term: "r4",
  reason: "for faster results with fewer questions"
}, {
  term: "r5",
  reason: "so we can follow up when it's time to see a doctor"
}, {
  term: "r6",
  reason: "so we can follow up to see how you're doing"
}]

// returns profile copy option associated with ab test, if any
export const getProfileInterestAbOption = () => {
  const term = window.profile_user_interest || window.location.search.replace('?ab_user_interest=', '')
  if (!term) return false
  return signUpOptions.find(o => o.term === term)
}


const Wrapper = styled.div`
  width: 100%;
  margin: 40px auto 24px;
  display: flex;
  padding-bottom: 32px;
  flex-direction: column;
  border-bottom: solid 1px ${colors.neutralLight};
  position: relative;
`

const EmailInput = styled(FormField)`
  padding-bottom: 12px;
  p {
    margin-bottom: 0;                                    
  }

  input {
    margin-top: 8px;
    border: 1px solid ${props => props.error ? colors.error : colors.neutralLightest};
  }
`

const SubmitButton = styled(Button)`
  width: 128px;
  margin: 0 0 0 auto;
`

const Header = styled(Text)`
  margin-bottom: 4px;
`

const ProfileInterestInput = (props) => {
  const { profileInterest, option } = props
  const { submitted, email, error, attempted } = profileInterest
  const valid = validateEmail(email)

  return (
    <Wrapper>
      <Header fontWeight="regular">We're working on new features</Header>
      <Header block>{`Save your profile and medical history ${option.reason}.`}</Header>
      <EmailInput
        value={email}
        onChange={props.onChange}
        type="email"
        name="email"
        maxLength="256"
        ariaLabel="email"
        placeholder="Email Address"
        errorMessage={error}
        error={!valid && attempted && !submitted}
        showError={attempted && !submitted}
      />
      <SubmitButton onClick={props.onSubmit} disabled={!valid}>Sign up</SubmitButton>
    </Wrapper>
  )
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e => {
    let { attempted, error } = ownProps.profileInterest
    dispatch(setProfileInterestEmail(e.target.value))
    if (attempted) dispatch(setProfileInterestAttempted(false))
    if (error && validateEmail(e.target.value)) dispatch(setProfileInterestError(null))
  },
  onSubmit: () => {
    dispatch(setProfileInterestAttempted(true))
    if ( validateEmail(ownProps.profileInterest.email) ) {
      dispatch(submitProfileInterestEmail(ownProps.option.reason))
    } else {
      dispatch(setProfileInterestError('Email is not valid'))
    }
  },
})

export default connect(null,mapDispatchToProps)(ProfileInterestInput)


// WEBPACK FOOTER //
// ./assets/completion/components/ProfileInterestInput.js